import styled from "styled-components";

const FormulaDiv = styled.div`
  color: #fff;
  height: 65%;
  overflow-x: hidden;
`;

const Formula = ({ formula }) => {
  return (
    <FormulaDiv>
      <h1>
        {formula}
      </h1>
    </FormulaDiv>
  );
};

export default Formula;